import { g as getDB, u as user } from "./index3.js";
import { g as generateSessionToken, c as createSession, s as setSessionTokenCookie } from "./auth.js";
import { b as private_env } from "./shared-server.js";
const createUUID = () => crypto.randomUUID();
const createAndLoginTempUser = async (event) => {
  const db = getDB();
  const userId = createUUID();
  const user$1 = {
    id: userId,
    temp: true,
    email: null,
    lastSeen: /* @__PURE__ */ new Date(),
    createdAt: /* @__PURE__ */ new Date()
  };
  await db.insert(user).values([user$1]).run();
  const sessionToken = generateSessionToken();
  const session = await createSession(sessionToken, userId);
  setSessionTokenCookie(event, sessionToken, session.expiresAt);
  return { user: user$1, session };
};
const loginUser = async (event, userId) => {
  const sessionToken = generateSessionToken();
  const session = await createSession(sessionToken, userId);
  setSessionTokenCookie(event, sessionToken, session.expiresAt);
};
const isAuthenticated = (locals) => !!(locals.user && !locals.user.temp);
const isAllowedEmail = (() => {
  if (private_env.ALLOWED_LOGIN_EMAILS) {
    const allowedEmails = private_env.ALLOWED_LOGIN_EMAILS.split(";").map(
      (email) => email.trim().toLowerCase()
    );
    return (email) => allowedEmails.includes(email.toLowerCase());
  } else if (private_env.ALLOWED_LOGIN_DOMAINS) {
    const allowedDomains = private_env.ALLOWED_LOGIN_DOMAINS.split(";").map(
      (domain) => domain.trim().toLowerCase()
    );
    return (email) => allowedDomains.some((domain) => email.toLowerCase().endsWith(`@${domain}`));
  }
  return () => true;
})();
export {
  isAllowedEmail as a,
  createUUID as b,
  createAndLoginTempUser as c,
  isAuthenticated as i,
  loginUser as l
};
